<template>
  <div class="row">
    <Form
      :chart-id="chartId"
      @submit="handleSubmit"
      @cancel="$router.push('/dashboard')"
      schema-endpoint="analytics/schema"
      chart-endpoint="enroll_admin/chart"
      :validation="validation"
    />
  </div>
</template>

<script>
import Form from "./Analytics/Form.vue";

export default {
  components: { Form },
  props: {
    chartId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      validation: {}
    };
  },
  methods: {
    handleSubmit({ parsedPayload, chartId }) {
      if (chartId) {
        return this.$http
          .put(`enroll_admin/chart/${chartId}`, parsedPayload)
          .then(() => this.$router.push("/dashboard"))
          .catch(({ response }) => {
            if (response.status === 422) {
              this.validation = response.data;
            }
          });
      }
      this.$http
        .post("enroll_admin/chart", parsedPayload)
        .then(() => this.$router.push("/dashboard"))
        .catch(({ response }) => {
          if (response.status === 422) {
            this.validation = response.data;
          }
        });
    }
  }
};
</script>
